import React, { useState } from 'react';

import { Stack } from '@mui/material';
import dayjs from 'dayjs';

import ContentCard from '../../../../components/ContentCard';
import DateNavigator from '../../../../components/DateNavigator';
import LessonScheduleView from '../../../../components/LessonScheduleView';
import { Class, Lesson } from '../../../../services/classes/types';

interface ScheduleCardProps {
  lessons?: Lesson[];
  classObj: Class;
}

const ScheduleCard = ({ classObj, lessons }: ScheduleCardProps) => {
  const [date, setDate] = useState(dayjs());

  return (
    <ContentCard
      variant="outlined"
      title="Schedule"
    >
      <Stack direction="column" spacing={2}>
        <DateNavigator
          date={date}
          onDateChange={setDate}
          dateIncrement={7}
          hideDateLabel
        />
        <LessonScheduleView
          lessons={lessons}
          startDatetime={date.valueOf()}
          maxWeeks={10}
          regularDay={classObj.day}
        />
      </Stack>
    </ContentCard>
  );
};
export default ScheduleCard;
